// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"75ed7a66","419":"75ed7a66","591":"75ed7a66","740":"75ed7a66","787":"75ed7a66","832":"75ed7a66","863":"75ed7a66","902":"75ed7a66","915":"75ed7a66"}[chunkId] + ".chunk.css";
};